/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import {
  Col, Row, Tooltip,
} from 'antd';
import { Waypoint } from 'react-waypoint';
import ListItem from 'Components/common/components/ListItem';
import PeopleWidget from 'Components/common/components/PeopleWidget';
import TagTip from 'Components/common/components/TagTip';
import styled from 'styled-components';
import ExportIcon from 'Components/common/assets/svgIcons/ExportIcon';
import {
  backgroundColorParsing,
  certificationSmoothBehavior,
  formatNumberWithCommas,
  getQueryPersonId,
  getQueryPersonType,
  isGuest,
  isGuestfromEmail,
  IsMobile, MidWidthApp, valueToObject,
} from 'Utils/UtilityFunctions';
import {
  boxShadow, maxWidth, retina,
  primaryFont, secondaryFont, wMedium, primaryHeadingColor, wLight, maxTablet, maxMobile, smMobile,
  nutenixColor,
  previousButtonSlider,
  minWidthApp,
  nextButtonSlider,
  wMBold,
  primaryColor,
} from 'Utils/utilsStyle';
import { CheckCircleFilled } from '@ant-design/icons';
import PersonalityPills from 'Components/common/components/PersonalityPills';
import ArrowRightIcon from 'Components/common/assets/svgIcons/ArrowRightIcon';
import PeopleCardLarge from 'Components/common/components/PeopleCardLarge';

import {
  personCard,
  personProfilePopups,
  profileLoading,
  selectAllPersonGroups,
  selectCommonalitiesDataList,
  selectCommonalitiesLoading,
  selectCommonalitiesTitle,
  selectExportSimilarPeopleLoading,
  selectInsightsData,
  selectInsightsLoading,
  selectPersonGroupsCount,
  selectPersonGroupsLoaded,
  selectPersonGroupsLoading,
  selectSearchedLoading,
  selectSearchedPerson,
  selectSearchedPersonData,
  selectSimilarPeopleData,
  selectSimilarPeopleFilters,
  selectFaqsLoading
} from 'Selector/PersonProfileSelector';
import { useDispatch, useSelector } from 'react-redux';
import {
  InsightsApproachInterests, InsightsCompatibility, PersonalityInsights,
  DealingInfo, Executive, PersonCard, PersonPopupResponse,
  SimilarPeopleData, SimilarPeopleFilters,
} from 'Types/PersonTypes';

import PersonalityInsightsSkeleton from 'Components/common/skeleton/PersonalityInsightsSkeleton';
import { useEffect, useState } from 'react';

import DragWrapper from 'Components/people/components/DragWrapper';
import PersonSkeleton from 'Components/common/skeleton/PersonSkeleton';
import AffinitySkeleton from 'Components/common/skeleton/AffinitySkeleton';
import ApproachTipSkeleton from 'Components/common/skeleton/ApproachTipSkeleton';
import SearchGlobalIcon from 'Components/common/assets/svgIcons/SearchGlobalIcon';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import { useMediaQuery } from 'react-responsive';
import {
  DISCLAIMER_MESSAGE,
  EMPTY_PERSONALITY_TYPES,
  MULTI_SALES_UNMAPPED_TEXT,
  SIMILAR_PEOPLE_ROUTE, TOOLTIP_SIMILAR_PEOPLE,
} from 'Utils/Constants';
import DisclaimerMessage from 'Components/common/components/DisclaimerMessage';
import classNames from 'classnames';
import {
  selectActivetype, selectHighlight, selectIsHighlighted,
  selectIsScroll, selectScrollToId, selectScrollToPage,
} from 'Selector/CertificationSelector';
import { actions as personProfileActions } from 'Slice/PersonProfileSlice';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { actions as helperActions } from 'Slice/HelperSlice';
import { actions } from 'Slice/PersonProfileSlice';
import { actions as uiActions } from 'Slice/UISlice';
import { actions as affinityActions } from '../../../Slice/AffinitySearchResultsSlice';
import SearchPersonSkeletonBlock from 'Components/common/skeleton/SearchPersonSkeletonBlock';
import { useLocation, useNavigate } from 'react-router-dom';
import GlobalButton from 'Components/common/components/GlobalButton';
import FilterSimilarPeople from 'Components/common/components/FilterSimilarPeople';
import Empty from 'Components/common/assets/svgIcons/Empty';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import InfoIconTwo from 'Components/common/assets/svgIcons/InfoIconTwo';
import { selectDisclessPersonality } from 'Selector/GlobalSearchContentSelector';
import Slider from 'react-slick';
import BuyerGroupCard from 'Components/common/components/BuyerGroupCard';
import BuyerGroupSkeleton from 'Components/common/skeleton/BuyerGroupSkeleton';
import CareerWidgetOverlay from './CareerWidgetOverlay';
import DrawerPersonIntent from './DrawerPersonIntent';
import DrawerPersonPersonality from './DrawerPersonPersonality';
import AffinitySearch from './AffinitySearch';
import TimeLineSlider from './TimeLineSlider';
import { selectMultipleSalesMode } from '../../../Selector/UISelector';
import BackIcon from '../../common/assets/svgIcons/BackIcon';
import MultiSalesAlignment from './MultiSalesAlignment';
import FAQs from './FAQs';
import { MULTI_SALES_EXTENDED_SEARCH_DISABLED_TEXT, MULTI_SALES_COMPANY_DISABLED_TEXT } from 'Utils/Constants';

const ProgressWrapper = styled.div<{ color: string }>`
  .progress-color-personality {
    height: 8px;
    width: 135%;
    margin: 5px 0;
    background: linear-gradient(to right, ${(props) => props.color} );
  }
  .heading {
    font-family: ${secondaryFont};
    font-size: 20px;
    line-height: 24px;
    -webkit-text-fill-color: transparent;
    background: linear-gradient(to right, #E13C39 0%, #EFB041 33%, #72C140 67%, #448EF7 100%);
    -webkit-background-clip: text;
    margin-bottom: 0px;
    font-weight: bold;
  }
`;

const PersonalityBlock = styled.div`
  margin-top: 53px;
  margin-bottom: 45px;
  .head {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    @media all and (max-width: ${maxMobile}){ 
    flex-direction: column;
    }
    .left-side{
      display: flex;
      align-items: center;
     @media all and (max-width: ${maxMobile}){ 
      width: 100%;
      display: flex;
      justify-content: flex-start;
     }
    }
    .right-side{
      display: flex;
      align-items: center;
      @media all and (max-width: ${maxMobile}){ 
       width: 100%;
       justify-content: flex-end;
       margin-top: 10px;
      }
      .export-similar-people {
        margin-right: 24px;
        .export_btn {
          min-width: 105px;
          @media all and (max-width: ${maxWidth}), ${retina} {
            min-width: 90px;
          }
          svg {
            width: 17px;
            margin-right: 10px;
            min-width: 17px;
            @media all and (max-width: ${maxWidth}), ${retina} {
              width: 12px;
              min-width: 12px;
            }
          }
        }
        @media all and (max-width: ${maxTablet}){ 
          .export_btn {
            width: 31px;
            height: 28px;
            padding: 0px 9px;
            svg {
              width: 14px;
              min-width: 14px;
            }
          }
        }
      } 
      .filter-similar-people {
        margin-right: 5px;
      }
    }
  }
  .insights-person {
    .person-item {
      margin-bottom: 0px;
    }
  }
`;

const Heading = styled.h2`
  font-size: 24px;
  font-weight: ${wMBold};
  font-family: ${secondaryFont};
  letter-spacing: -0.66px;
  color: ${primaryHeadingColor};
  margin-bottom: 0px;
  @media all and (max-width: ${maxTablet}){
    font-size: 16px;
  }
`;

const LearnMore = styled.span<{ color: string }>`
  font-size: 14px;
  font-weight: ${wMedium};
  font-family: ${secondaryFont};
  line-height: 36px;
  letter-spacing: -0.35px;
  color: ${(props) => props.color};
  cursor: pointer;
  display: flex;
  align-items: center;
  svg {
    margin-left: 10px;
    margin-top: 3px;
  }
  a {
    color: ${(props) => props.color};
    display: flex;
    align-items: center;
   
  }
`;

const SimilarPeopleHeading = styled.h3`
  font-size: 24px;
  font-weight: ${wMedium};
  font-family: ${secondaryFont};
  letter-spacing: -0.55px;
  color: ${primaryHeadingColor};
  margin-bottom: 0px;
  @media all and (max-width: ${maxTablet}){
    font-size: 16px;
  }
`;

const TimeLineWidget = styled.div`
  z-index: 0;
  padding: 50px 25px 8px 25px;
  box-shadow: ${boxShadow};
  background:#fff;
  border-radius: 16px;
  height: 100%;
  width: 102%;
  margin-left: -20px;
  margin-top: 25px;
  position: relative;
  min-height: 532px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    min-height: 462px;
    padding: 48px 20px 8px 20px;
    border-radius: 12px;
    width: 101%;
    margin-left: -10px;
    margin-top: 0px;
    @media all and (max-width: ${maxMobile}) {
      padding: 48px 10px 8px 10px;
    }
  }
  @media all and (max-width: ${maxMobile}) {
    min-height: auto;
    width: 100%;
    margin-left: 0px;
  }

  .timeLine-spacing {
    margin: 63px 0 0 20px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     margin: 40px 0 0 20px; 
    }
    @media all and (max-width: ${maxMobile}) {
     margin: 10px 0 0 0;  
    }
  }
`;

const AffinityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .persons-container {
    width: 100%;
  }
  .progress-bar-container {
    max-width: 440px;
    margin-top: 20px;
    display: flex;

    @media all and (max-width: ${maxTablet}) {
      max-width: 290px;
    }
    @media all and (max-width: ${smMobile}) {
      max-width: 200px;
    }
  }
  .pills-first-half {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-right: 20px;
    margin-bottom: 30px;
    span {
      text-transform: capitalize;
      white-space: nowrap;
      width: fit-content;
      text-align: right;
      @media all and (max-width: 1150px) {
        font-size: 12px;
        padding: 3px 10px;
      }
    }
    .skeleton-box {
      @media all and (max-width: 1150px) {
        height: 20px;
        width: 80px;
        min-width: 80px;
      }
    }
  }
  .person-first-half {
    width: fit-content;
    margin-right: -110px;
    @media all and (max-width: ${maxMobile}) {
    margin-right: -150px;
    }
    .person-skeleton-loader {
      margin-bottom: 0px;
      .person-skeleton-wrapper {
        .person-box {
         @media all and (max-width: 1280px) {
          width: 120px;
          height: 120px;
          min-width: 120px;
         }
         @media all and (max-width: ${smMobile}) {
          width: 100px;
          height: 100px; 
          min-width: 100px;
         }
        }
        .badge-box {
          @media all and (max-width: 1280px) {
            width: 95px;
          }
        }
      }
    }
  }
  .second-person-wrapper {
    .person-name-heading {
     display:none;
    }
    .person-skeleton-loader {
      margin-bottom: 0px;
      .person-skeleton-wrapper {
        .person-box {
         @media all and (max-width: 1280px) {
          width: 120px;
          height: 120px;
          min-width: 120px;
         }
         @media all and (max-width: ${smMobile}) {
          width: 100px;
          height: 100px; 
          min-width: 100px;
         }
        }
        .badge-box {
          @media all and (max-width: 1280px) {
            width: 95px;
          }
        }
      }
    }
  }
  .pills-second-half {
    display: flex;
    flex-direction: column;
    margin-left: -20px;
    margin-bottom: 30px;
    text-transform: capitalize;
    span {
      white-space: nowrap;
      width: fit-content;
      text-align: right;
      @media all and (max-width: 1150px) {
        font-size: 12px;
        padding: 3px 10px;
      }
    }
    .skeleton-box {
      @media all and (max-width: 1150px) {
        height: 20px;
        width: 80px;
        min-width: 80px;
      }
    }
  }
`;

const HeadingTile = styled.h1`
  font-size: 24px;
  font-weight: ${wMedium};
  font-family: ${secondaryFont};
  letter-spacing: -0.55px;
  color: ${primaryHeadingColor};
  margin-bottom: 0px;
  @media all and (max-width: ${maxTablet}){
   font-size: 16px; 
  }
`;

const ToolTipAffinity = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .left-section {
    display: flex;
    align-items: center;
    column-gap: 8px;
    .back-icon-div {
      width: 20px;
      height: 20px;
      margin-right: 4px;
      svg {
        height: 20px;
        width: 20px;
      }
    }
  }
  .right-section {
    @media all and (max-width: ${maxMobile}) {
      padding-right: 12px;
    }
  }
  .icon-area {
    height: 19px;
    width: 20px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      height: 17px;
      width: 15px;
    }
    @media all and (max-width: ${maxTablet}) {
      height: 18px;
      width: 12px;
    }
    svg {
      g, path {
        fill: rgb(97, 97, 97);
      }
    }
  }
  .tooltip-text {
    color: black;
    font-family: ${primaryFont};
    font-size: 13px;
    line-height: 13px;
    font-weight: ${wLight};
    white-space: pre-wrap;
    .bold {
      font-weight: 900;
      margin-right: 5px;
    }
    .light {
      margin-left:5px;
    }
    svg {
      max-width: 17px;
      background-color: lightgray;
      height: 15px;
      width: 17px;
      max-height: 15px;
      border: 3px solid lightgray;
      border-radius: 10px;    
      margin: 0px;
      margin: -4px 5px;  
      g, path {
          fill: gray;
      }
    }
  }
  .ant-tooltip {
    @media all and (max-width: ${smMobile}) {
      padding-top: 0px;
    }
  }
  .ant-tooltip-content {
      max-width: 455px;
      border-radius: 10px;
      @media all and (max-width: ${maxMobile}) {
        min-width: 250px;
        width: 250px;
      }
      @media all and (max-width: ${smMobile}) {
        width: 200px;
        min-width: 200px;
        margin-left: 15px;
        .ant-tooltip-arrow {
          display: none;
        }
      }
   }
  .ant-tooltip-inner {
    border-radius: 10px;
    color: #000;
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: ${wLight};
    line-height: 18px;
    padding: 10px;
    @media all and (max-width: ${smMobile}) {
      font-size: 12px;
      line-height: 14px;
      padding: 8px;
    }
   }
`;

const Wrapper = styled.div`
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
  }
  .compatibility-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 450px;
    @media all and (max-width:1550px) {
      min-width: 450px;
    }
    @media all and (max-width:1300px) {
      min-width: 350px;
    }
    @media all and (max-width:1210px) {
      min-width: 290px;
    }
    @media all and (max-width:1130px) {
      min-width: 240px;
    }
    @media all and (max-width: ${maxTablet}) {
      min-width: 300px;
    }
    @media all and (max-width: ${smMobile}) {
      min-width: 230px;
      img {
        height: 66px;
        margin-left: 70px;
      }
    }
    h6 {
      margin-left: 50px;
      @media all and (max-width: ${maxMobile}) {
        margin-left: 100px;
        font-size: 16px;
      }
      @media all and (max-width: ${smMobile}) {
        margin-left: 55px;
        font-size: 11px;
        line-height: 13px;
      }
    }
  }
  .affinity-block {
    &.multi-sales {
      .pills-one-liner {
        .ant-col {
          .ant-spin-nested-loading {
            .multi-sales-container {
              margin: -43px 0 59px !important;
              .table-width-decide {
                .first-row {
                  .user-section {
                    &.has-add-alignment {
                      .remove-alignment-btn {
                        border-radius: 16px 0px 0px 0px !important;
                      }
                    }
                  }
                }
              }
            }
            .ant-spin-container > .multi-sales-container:first-child {
              margin: 24px auto 59px auto !important;
            }
            .ant-spin-spinning {
              max-height: 100% !important;
            }
          }
        }
      }
    }
    padding: 27px 48px 8px 48px;
    box-shadow: 0px 0px 24px rgb(0 0 0 / 10%);
    background: #fff;
    border-radius: 16px;
    width: 100%;
    height: 100%;
    margin-left: 0px !important;
    margin-right: 0px !important;
    user-select: none;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 27px 20px 8px 27px;
    }
    @media all and (max-width: ${maxMobile}) {
      padding: 27px 0px 8px 10px;
    }
    .affinity-container {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
      width: 100%;
      &.noMapPerson {
        .progress-bar-container {
          @media all and (max-width: ${maxTablet}) { 
            margin-top: 0px;
          }
        }
        .compatibility-status {
          @media all and (max-width: ${maxTablet}) { 
            margin-top: 0px;
          }
        }
        .isFirstPerson {
          @media all and (max-width: ${maxTablet}) { 
            margin-top: 38px;
          }
          @media all and (max-width: ${smMobile}) { 
            margin-top: 33px;
          }
        }
      }
    }
    .commonalities-container {
      margin-top: 16px;
      margin-bottom: 24px;
      .commonalities-area {
        .common-points {
          flex-wrap: wrap;
          @media all and (max-width: ${maxMobile}) {
            flex-direction: column;
          }
          .horizontal-tips {
            align-items: center;
            @media all and (max-width: ${maxMobile}) {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .people-group-section {
    .group-heading {
      margin-top: 36px;
    }
    .groups-slider {
      padding: 32px 23px 0px 23px;
      .slick-slider {
        .slick-track {
          margin-left: 0px !important;
        }
        .slick-arrow {
          &.slick-prev {
            z-index: 1;
            &:before {
              height: 40px;
              width: 28px;
              background-size: contain;
              background-repeat: no-repeat;
              background-image: url(${previousButtonSlider});
              content: '';
              position: absolute;
              top: 0px;
              left: -43px;
              @media all and (max-width: ${maxWidth}), ${retina} {
                left: -38px;
              }
              @media all and (max-width: ${minWidthApp}) and (min-width: ${maxTablet}) {
                width: 20px;
                height: 30px;
                left: -2px;
              }
              @media all and (max-width: ${maxTablet}) {
                left: -2px;
                height: 20px;
                width: 20px;
              }
            }
          }
          &.slick-next {
            &:before {
              height: 40px;
              width: 28px;
              background-size: contain;
              background-repeat: no-repeat;
              background-image: url(${nextButtonSlider});
              content: '';
              position: absolute;
              top: 0px;
              right: -38px;
              @media all and (max-width: ${maxWidth}), ${retina} {
                right: -33px;
              }
              @media all and (max-width: ${minWidthApp}) and (min-width: ${maxTablet}) {
                width: 20px;
                height: 30px;
                right: 5px;
              }
              @media all and (max-width: ${maxTablet}) {
                right: 7px; 
                height: 20px;
                width: 20px;
              }
            }
          }
        }
        .slick-list {
          .slick-slide {
            .buyer-group-slide {
              width: 90% !important;
            }
          }
        }
      }
    }
  }
  .approach-tips-area {
    &.m-tip-min {
      .tip-item-c {
        margin: 10px 0px;
      }
    }
    &.m-tip-max {
      .tip-item-c {
        margin: 20px 0px;
      }
    }
  }
  .tips-details-wrapper {
    max-height: 130px;
    overflow: hidden;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     max-height: 115px;
    }
    @media all and (max-width: ${maxTablet}) {
     max-height: 140px;
    }
    @media all and (max-width: ${maxMobile}) {
     max-height: fit-content;
    }
  }
  .wrapper-descripition {
    text-align: center;
    font-size: 24px;
    font-weight: ${wMedium};
    font-family: ${secondaryFont};
    letter-spacing: -0.55px;
    color: #979797;
    margin-bottom: 0px;
    width: 70%;
    margin: 80px auto 0px auto;
    padding: 0px 20px !important;
    transform: translateX(-60px);
    @media all and (max-width: ${maxMobile}) {
      font-size: 18px;
    }
  }
  .first-person-wrapper, .second-person-wrapper {
    display: flex;
    align-items: center;
  }
  .first-person-wrapper {
    padding-left: 20px;
    @media all and (max-width: ${maxMobile}) {
      padding-left: 0px;
    }
    @media all and (max-width: ${smMobile}) {
      padding-left: 5px;
    }
  }
  .spacingStyle{
    margin: 18px -90px 0px 20px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin: 18px -30px 0px 20px;
    }

    @media all and (max-width: ${maxMobile}) {
      margin: 18px 0px 0px 20px;
    }

  }
  .how-to-approach {
    align-items: flex-start;
    @media all and (max-width: ${maxMobile}) {
      flex-direction: column;
    }
    .horizontal-tips {
      @media all and (max-width: ${maxMobile}) {
        width: 100%;
      }
    }
  }
`;

const SplashSrc = styled.img`
  max-width: 120%;
  height: auto;
  @media all and (max-width:1210px) {
    max-width: 100%;
    height: 95px;
    margin-left: 35px;
  }
  @media all and (max-width: ${maxTablet}){
   height: 60px; 
  }
  @media all and (max-width: ${maxMobile}) {
    margin-left: 75px;
  }
  @media all and (max-width: 420px) {
    height: 45px;
    margin-left: 100px;
  }
  .similar-people-tooltip {
    /* height: 22px; */
  }
`;

const FAQItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 0;
  gap: 12px;
  cursor: pointer;
  @media all and (max-width: ${maxMobile}) {
    align-items: flex-start;
    padding: 12px 0;
  }
`;

const QuestionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  @media all and (max-width: ${maxMobile}) {
    align-items: flex-start;
  }
`;

type Props = {
  isDrag: (d: boolean) => void
  propColor: string
  faqs?: string[]
  onFaqClick?: (faq: string, faqIdx: number) => void
  companyName?: string
};

const PersonalityInsight = function PersonalityInsight(props: Props) {
  const { isDrag, propColor, faqs, onFaqClick, companyName = 'Not Employed' } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const personId: number = getQueryPersonId();
  const personType: string = getQueryPersonType();
  const isMob = IsMobile();
  const isMidWidth = MidWidthApp();
  const [similarPeopleArr, setSimilarPeople] = useState<Executive[]>([]);
  const loading: boolean = useSelector(selectInsightsLoading);
  const isMinDesktop = useMediaQuery({ minWidth: 1171, maxWidth: 1300 });
  const isSmDesktop = useMediaQuery({ maxWidth: 1170 });
  const insights: PersonalityInsights[] = useSelector(selectInsightsData);
  const compatibility: InsightsCompatibility = insights.find((insight) => insight.type === 'compatibility') as InsightsCompatibility;
  const approach: InsightsApproachInterests = insights.find((insight) => insight.type === 'approach') as InsightsApproachInterests;
  const interests: InsightsApproachInterests = insights.find((insight) => insight.type === 'interests') as InsightsApproachInterests;
  const dealingInfo: DealingInfo = insights.find((insight) => insight.type === 'dealingInfoV2') as DealingInfo;
  const similarPeopleData: SimilarPeopleData = useSelector(selectSimilarPeopleData);
  const similarPeopleFilters: SimilarPeopleFilters = useSelector(selectSimilarPeopleFilters);
  const personProfileCard: PersonCard = useSelector(personCard);
  const personPopups: PersonPopupResponse = useSelector(personProfilePopups);
  const searchedPersonLoading: boolean = useSelector(selectSearchedLoading);
  const searchedPersonData: PersonalityInsights[] = useSelector(selectSearchedPersonData);
  const selectedPerson: Executive = useSelector(selectSearchedPerson);
  const isSelectedSearchedPerson = selectedPerson
    && (selectedPerson?.personId !== undefined || selectedPerson?.personId !== undefined);

  const searchedPersonCompatibility: InsightsCompatibility = searchedPersonData.find(
    (insight) => insight.type === 'compatibility',
  ) as InsightsCompatibility;
  const searchedPersonApproach: InsightsApproachInterests = searchedPersonData.find(
    (insight) => insight.type === 'approach',
  ) as InsightsApproachInterests;
  const cardLoading: boolean = useSelector(profileLoading);
  const scrollToId: string = useSelector(selectScrollToId);
  const isScroll: boolean = useSelector(selectIsScroll);
  const scrollToPage: string = useSelector(selectScrollToPage);
  const personYou = compatibility && compatibility?.data[0]?.persons[0];
  const personOther = compatibility && compatibility?.data[0]?.persons[1];
  const color = personOther && personOther?.archeType ? personOther.archeType.color : propColor;
  const compatibilityMatch = compatibility && compatibility?.data[0]?.match;
  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const isHighlighted = useSelector(selectIsHighlighted);
  const exportLoading: boolean = useSelector(selectExportSimilarPeopleLoading);
  const disclessPersonality = useSelector(selectDisclessPersonality);
  const {
    people, loading: similarLoading, title, count, page, loaded,
  } = similarPeopleData;
  const commonalitiesData = useSelector(selectCommonalitiesDataList);
  const commonalitiesLoading = useSelector(selectCommonalitiesLoading);
  const commonalitiesTitle = useSelector(selectCommonalitiesTitle);
  const formattedCount = formatNumberWithCommas(count);
  const allPersonGroups = useSelector(selectAllPersonGroups);
  const personGroupsCount = useSelector(selectPersonGroupsCount);
  const personGroupsLoaded = useSelector(selectPersonGroupsLoaded);
  const personGroupsLoading = useSelector(selectPersonGroupsLoading);
  const isMultipleSalesAlignment = useSelector(selectMultipleSalesMode);
  const faqsLoading = useSelector(selectFaqsLoading);
  const guestUser = isGuest() || isGuestfromEmail();

  const isPersonEmployed: boolean = (companyName !== 'Not Employed');
  const personYouEmployed: boolean = !!personYou?.companyId;
  const unmappedUser: boolean = compatibilityMatch === 'Compare';
  const extendedSearchDisableText = MULTI_SALES_EXTENDED_SEARCH_DISABLED_TEXT;
  const companyDisableText = MULTI_SALES_COMPANY_DISABLED_TEXT;
  const unmappedUserText = MULTI_SALES_UNMAPPED_TEXT;

  const {
    filters,
  } = similarPeopleFilters;


  const tooltipText = (
    !isMultipleSalesAlignment ? (
      <span className="tooltip-text">
        <span className="bold">
          Sales Alignment
        </span>
        gauges the compatibility between you and the person being viewed.
        You can also check the Sales Alignment between that person
        <span className="light">
          and other people by using the
          <SearchGlobalIcon />
          search option.
        </span>
      </span>
    ) : (
      <span className='tooltip-text'>
        Align up to four key people across different companies to uncover relationship dynamics, assess how well sales efforts are aligned, and gain deeper insights into potential engagement opportunities. This helps identify areas of collaboration, influence, and strategic connection between teams or organizations.
      </span>
    )
  );

  useEffect(() => {
    dispatch(uiActions.multipleSalesAlignment(false));
  }, [location.pathname, location.search])

  useEffect(() => {
    if (!personGroupsLoaded && personProfileCard) {
      dispatch(actions.getPersonGroups({
        personId: personProfileCard?.personId,
      }));
    }
  }, [personProfileCard]);

  const buyerGroupSlider = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    if (personYou?.personId && personOther?.personId && !isSelectedSearchedPerson) {
      dispatch(actions.getPersonCommonalities({
        fromPersonId: personYou?.personId,
        toPersonId: personOther?.personId,
      }));
    }
  }, [personYou?.personId, personOther?.personId, isSelectedSearchedPerson]);

  useEffect(() => {
    if (isSelectedSearchedPerson && selectedPerson?.personId && personOther?.personId) {
      dispatch(actions.getPersonCommonalities({
        fromPersonId: selectedPerson?.personId,
        toPersonId: personOther?.personId,
      }));
    }
  }, [selectedPerson?.personId, personOther?.personId, isSelectedSearchedPerson]);

  useEffect(() => {
    if (cardLoading && personType === 'EXECUTIVE' && personId) {
      dispatch(actions.getSimilarPeople({ personId, type: personType, page: 1 }));
    } else if (personProfileCard && personProfileCard.personId && personType === 'LIVESEARCH' && personId) {
      if (!(similarPeopleData && similarPeopleData.title.length)) {
        dispatch(actions.getSimilarPeople(
          { personId: personProfileCard.personId, type: personProfileCard.personType, page: 1 },
        ));
      }
    }
  }, [personId, cardLoading]);

  useEffect(() => {
    if (people && people.length) {
      setSimilarPeople(people.slice(0, 6));
    }
  }, [similarPeopleData.people]);

  useEffect(() => {
    if (isScroll && scrollToPage.includes('/person/') && insights && insights?.length && currentType === 'affinity_section') {
      certificationSmoothBehavior(scrollToId);
      dispatch(certificationActions.setIsScroll(false));
    }
  }, [scrollToId, isScroll, insights]);

  const SeeAllOrLess = () => {
    dispatch(helperActions.callFlurryEvent(
      valueToObject('similar_people_see_more_click', 0, {
        personId,
        type: personType,
        host: window.location.href,
      }),
    ));
    if (personProfileCard && personProfileCard?.personId) {
      dispatch(actions.saveProfile(personId));
      navigate(`${SIMILAR_PEOPLE_ROUTE}${personProfileCard?.personId}&personType=${personProfileCard?.personType}`);
    }
  };

  const { archeType } = personProfileCard || {};

  const splashImage = () => (isSelectedSearchedPerson
    ? searchedPersonCompatibility.data[0]?.affinityImage
    : compatibility.data[0].affinityImage);

  useEffect(() => {
    if (insights && insights.length && !isHighlighted && !isScroll && currentType === 'affinity_section') {
      dispatch(certificationActions.setHighlight(true));
      dispatch(certificationActions.setIsHighlighted(false));
    }
  }, [isScroll, currentType, insights]);

  const handleExport = () => {
    dispatch(helperActions.callFlurryEvent(
      valueToObject('similar_people_export_click', 0, {
        personId,
        type: personType,
        host: window.location.href,
      }),
    ));
    const filtersObj = filters.filter((filter) => filter.isSelected);
    if (personProfileCard.personId) {
      dispatch(actions.getSimilarPeopleExport({
        personId: personProfileCard.personId,
        ...(personProfileCard.personType && { type: personProfileCard.personType }),
        ...(filtersObj.length > 0 && { companyIds: filtersObj.map((obj) => obj.companyId).join(',') }),
      }));
    }
  };

  const setMultipleSalesMode = (value: boolean) => {
    dispatch(uiActions.multipleSalesAlignment(value));
  }

  const backBtnMultiSalesHandler = () => {
    setMultipleSalesMode(false);
    dispatch(affinityActions.affinitySearchResultReset());
    dispatch(personProfileActions.resetMultiSalesAlignment());
  }

  const getMultiSalesBtnTooltipText = () => {
    if (!isPersonEmployed) return companyDisableText;
    if (unmappedUser && !isSelectedSearchedPerson) return unmappedUserText;
    return '';
  };

  return (
    loading
      ? <PersonalityInsightsSkeleton />
      : (
        <Waypoint onEnter={() => { dispatch(personProfileActions.pushCurrentSection('xiQ insights')); }} onLeave={() => { dispatch(personProfileActions.removeCurrentSection('xiQ insights')); }}>
          <div id="certification-person-affinity">
            <Wrapper className="personality-insight-wrapper" id="tabs-details">
              {personYou && personOther && personYou.personId !== personOther.personId
                && !guestUser && !disclessPersonality && !isMultipleSalesAlignment
                ? (
                  <Row
                    gutter={16}
                    className={classNames('pills-one-liner affinity-block', { highlightedComponent: isHighlight && currentType === 'affinity_section' })}
                  >
                    <ToolTipAffinity>
                      <div className="left-section">
                        <HeadingTile>{compatibility?.title}</HeadingTile>
                        <Tooltip
                          arrow={false}
                          placement="bottomLeft"
                          title={tooltipText}
                          getPopupContainer={(e: HTMLElement) => e}
                          className="tooltip"
                          color="#fff"
                        >
                          <span className="icon-area">
                            <InfoIconTwo />
                          </span>
                        </Tooltip>
                      </div>
                      <div className="right-section">
                        <Tooltip
                          arrow={false}
                          trigger="hover"
                          placement="bottomRight"
                          title={getMultiSalesBtnTooltipText()}
                          color="#fff"
                          overlayStyle={{ maxWidth: 'calc(100vw - 20px)' }}
                          getPopupContainer={(e: HTMLElement) => e}
                        >
                          <div>
                            <GlobalButton
                              title="Multiple Sales Alignment"
                              outlineColor={primaryColor}
                              bgColor={primaryColor}
                              textColor="#fff"
                              borderRadius='8px'
                              innerSpace='8px 16px'
                              onButtonClick={() => setMultipleSalesMode(true)}
                              disabled={searchedPersonLoading || (unmappedUser && !isSelectedSearchedPerson)}
                            />
                          </div>
                        </Tooltip>
                      </div>
                    </ToolTipAffinity>
                    {compatibility.data && compatibility.data[0].description
                      ? <div className="wrapper-descripition ">{compatibility.data[0].description}</div> : null}
                    {personYou.personId !== personOther.personId && (
                      <Row gutter={16} className={classNames('pills-one-liner affinity-container', { noMapPerson: compatibilityMatch === 'Compare' && !isSelectedSearchedPerson })}>
                        {compatibility && personYou.personId !== personOther.personId
                          && (
                            <AffinityWrapper>
                              <div className="d-flex align-items-center justify-content-between px-3 persons-container">
                                <div className="first-person-wrapper">
                                  {!isMob ? (
                                    <div className="pills-first-half">
                                      {searchedPersonLoading ? (
                                        [1, 2, 3, 4].map(() => (
                                          <SkeletonCustom
                                            height="28px"
                                            width="105px"
                                            diameter="25px"
                                            margin="10px 9px 0px 0px"
                                            marginSm="10px 9px 0px 0px"
                                          />
                                        ))
                                      )
                                        : isSelectedSearchedPerson
                                          && searchedPersonCompatibility
                                          ? searchedPersonCompatibility
                                            ?.data[0]
                                            ?.persons[0]
                                            .affinityPoints?.map(
                                              (item: string) => (
                                                <PersonalityPills
                                                  bgColor={selectedPerson.archeType.color}
                                                  title={item}
                                                  padding="6px 20px"
                                                  margin="10px 9px 0px 0px"
                                                  fontSize="16px"
                                                  fontSizeSm="14px"
                                                />
                                              ),
                                            )
                                          : personYou
                                            .affinityPoints?.map((item: string) => (
                                              <PersonalityPills
                                                bgColor={personYou.archeType.color}
                                                title={item}
                                                padding="6px 20px"
                                                margin="10px 9px 0px 0px"
                                                fontSize="16px"
                                                fontSizeSm="14px"
                                              />
                                            ))}
                                    </div>
                                  ) : null}
                                  <div className="person-first-half">
                                    {searchedPersonLoading ?
                                      <PersonSkeleton hideBtn hideTitle />
                                      : (
                                        <DragWrapper
                                          key={isSelectedSearchedPerson
                                            ? selectedPerson.personId : personYou.personId}
                                          isDrag={isDrag}
                                        >
                                          <PeopleWidget
                                            diameter={`${isMinDesktop ? '216px' : isSmDesktop ? '196px' : '246px'}`}
                                            diameterXsm="196px"
                                            firstPerson
                                            wrapperColor={backgroundColorParsing(
                                              isSelectedSearchedPerson
                                                ? selectedPerson.personalityTypes
                                                : personYou.personalityTypes,
                                            )}
                                            personalityTypesColors={
                                              isSelectedSearchedPerson
                                                ? selectedPerson.personalityTypes
                                                : personYou.personalityTypes
                                            }
                                            personId={isSelectedSearchedPerson
                                              ? selectedPerson.personId : personYou.personId}
                                            type={isSelectedSearchedPerson
                                              ? selectedPerson.personType : personYou.personType}
                                            logo={isSelectedSearchedPerson
                                              ? selectedPerson.personImage : personYou.personImage}
                                            margin="0px"
                                            ringPadding="0px"
                                            ringPaddingSm="0px"
                                            showPersonName={false}
                                            personName={isSelectedSearchedPerson
                                              && selectedPerson.personId !== personYou.personId
                                              ? selectedPerson?.personName : 'You'}
                                            holoDiameterHeight={`${isMinDesktop ? '186px' : isSmDesktop ? '166px' : '216px'}`}
                                            holoDiameterWidth={`${isMinDesktop ? '206px' : isSmDesktop ? '186px' : '236px'}`}
                                            holoDiameterMinWidth="186px"
                                            holoDiameterMinHeight="166px"
                                            hidePersonality={false}
                                            persona={isSelectedSearchedPerson
                                              ? selectedPerson.archeType.color
                                              : personYou.archeType.color}
                                            isAffinitySearch
                                            personality={isSelectedSearchedPerson
                                              ? selectedPerson.archeType?.name
                                              : personYou.archeType?.name}
                                            personaType={isSelectedSearchedPerson
                                              ? selectedPerson?.archeType?.name : personYou?.archeType?.name}
                                            executiveType={isSelectedSearchedPerson
                                              ? selectedPerson.personType : personYou.personType}
                                          />
                                        </DragWrapper>

                                      )}
                                    {personProfileCard && personProfileCard.personId ? (
                                      <AffinitySearch
                                        name={isSelectedSearchedPerson
                                          ? selectedPerson?.personName : compatibilityMatch !== 'Compare' ? 'You' : ''}
                                        loading={searchedPersonLoading}
                                        defaultOpen={compatibilityMatch === 'Compare'}
                                        profileId={personOther.personId}
                                        showPopUp={personPopups.showPlanPopup}
                                      />
                                    ) : null}

                                  </div>
                                </div>
                                <div className="progress-bar-container">
                                  {searchedPersonLoading ?
                                    <AffinitySkeleton />
                                    : (
                                      <ProgressWrapper color={
                                        backgroundColorParsing(
                                          [
                                            isSelectedSearchedPerson
                                              ? selectedPerson.personalityTypes[0]
                                              : personYou.personalityTypes[0],
                                            personOther.personalityTypes[0],
                                          ],
                                        )
                                      }
                                      >
                                        <div className="compatibility-status">
                                          <SplashSrc src={splashImage()} alt="splash" />
                                          <h6 className="heading">
                                            {isSelectedSearchedPerson && searchedPersonCompatibility
                                              ? searchedPersonCompatibility.data[0]?.groupMatch[0]
                                              : compatibility.data[0]?.groupMatch[0]}
                                          </h6>
                                          <h6 className="heading">
                                            {isSelectedSearchedPerson && searchedPersonCompatibility
                                              ? searchedPersonCompatibility.data[0]?.groupMatch[1]
                                              : compatibility.data[0]?.groupMatch[1]}

                                          </h6>
                                        </div>
                                      </ProgressWrapper>
                                    )}
                                </div>
                                <div className="second-person-wrapper">
                                  {searchedPersonLoading ?
                                    <PersonSkeleton hideBtn hideTitle className="mr-5" />
                                    : (
                                      <DragWrapper key={personOther.personId} isDrag={isDrag}>
                                        <PeopleWidget
                                          diameter={`${isMinDesktop ? '216px' : isSmDesktop ? '196px' : '246px'}`}
                                          diameterXsm="196px"
                                          secondPerson
                                          wrapperColor={backgroundColorParsing(
                                            personOther.personalityTypes,
                                          )}
                                          personalityTypesColors={personOther.personalityTypes}
                                          logo={personOther.personImage}
                                          margin="0px"
                                          showPersonName
                                          personName={personOther?.personName}
                                          holoDiameterHeight={`${isMinDesktop ? '186px' : isSmDesktop ? '166px' : '216px'}`}
                                          holoDiameterWidth={`${isMinDesktop ? '206px' : isSmDesktop ? '186px' : '236px'}`}
                                          holoDiameterMinWidth="186px"
                                          holoDiameterMinHeight="166px"
                                          hidePersonality={false}
                                          persona={personOther.archeType.color}
                                          isAffinitySearch
                                          personality={personOther.archeType?.name}
                                          ringPadding="0px"
                                          ringPaddingSm="0px"
                                          personaType={personOther?.archeType?.name}
                                          personId={personOther.personId}
                                          executiveType={personOther.personType}
                                        />
                                      </DragWrapper>

                                    )}
                                  {!isMob ? (
                                    <div className="pills-second-half">
                                      {searchedPersonLoading ? (
                                        [1, 2, 3, 4].map(() => (
                                          <SkeletonCustom
                                            height="28px"
                                            width="105px"
                                            diameter="25px"
                                            margin="10px 9px 0px 0px"
                                            marginSm="10px 9px 0px 0px"
                                          />
                                        ))
                                      ) : (
                                        personOther.affinityPoints?.map((item: string) => (
                                          <PersonalityPills
                                            bgColor={personOther.archeType.color}
                                            title={item}
                                            padding="6px 20px"
                                            margin="10px 9px 0px 0px"
                                            fontSize="16px"
                                            fontSizeSm="14px"
                                          />
                                        ))
                                      )}
                                    </div>
                                  ) : null}

                                </div>
                              </div>
                            </AffinityWrapper>
                          )}
                      </Row>
                    )}
                    <Row gutter={16} className="pills-one-liner justify-content-center w-100">
                      {searchedPersonLoading ? (
                        <Col span={`${interests && interests.dataList?.length > 0 ? isMob ? 24 : 12 : 24}`} className="100%">
                          <CareerWidgetOverlay title={approach.title}>
                            <div className="d-flex flex-column ">
                              {[1, 2, 3].map((item) => (
                                <ApproachTipSkeleton key={item} />
                              ))}
                            </div>
                          </CareerWidgetOverlay>
                        </Col>
                      ) : isSelectedSearchedPerson && searchedPersonApproach
                        && selectedPerson.personId !== personOther.personId
                        && selectedPerson.personId !== personYou.personId
                        ? (
                          <Col
                            span={`${interests && interests.dataList?.length > 0 ? isMob ? 24 : 12 : 24}`}
                            className={`approach-tips-area ${interests && interests.dataList?.length > 0 ? 'm-tip-min' : 'm-tip-max ml-0 mr-0'}`}
                          >
                            <CareerWidgetOverlay title={searchedPersonApproach.title}>
                              <div className={`${interests && interests.dataList?.length > 0 ? '' : 'd-flex flex-direction-column align-items-center how-to-approach'}`}>
                                {searchedPersonApproach.dataList?.map(
                                  (d) => (
                                    <ListItem
                                      className={`${interests && interests.dataList?.length > 0 ? '' : 'horizontal-tips'}`}
                                      title={d}
                                      icon={(
                                        <CheckCircleFilled
                                          style={{ color }}
                                        />
                                      )}
                                      showTooltip={isMidWidth}
                                    />
                                  ),
                                )}
                              </div>
                            </CareerWidgetOverlay>
                          </Col>
                        ) : approach.dataList.length !== 0
                        && personYou.personId !== personOther.personId && (
                          <Col
                            span={`${interests && interests.dataList?.length > 0 ? isMob ? 24 : 12 : 24}`}
                            className={`approach-tips-area ${interests && interests.dataList?.length > 0 ? 'm-tip-min' : 'm-tip-max ml-0 mr-0'}`}
                          >
                            <CareerWidgetOverlay title={approach.title}>
                              <div className={`${interests && interests.dataList?.length > 0 ? '' : 'd-flex flex-direction-column how-to-approach'}`}>
                                {approach.dataList?.map(
                                  (d) => (
                                    <ListItem
                                      className={`${interests && interests.dataList?.length > 0 ? '' : 'horizontal-tips'}`}
                                      title={d}
                                      icon={(
                                        <CheckCircleFilled
                                          style={{ color }}
                                        />
                                      )}
                                      showTooltip={isMidWidth}
                                    />
                                  ),
                                )}
                              </div>
                            </CareerWidgetOverlay>
                          </Col>
                        )}

                      {interests && (
                        <Col span={isMob ? 24 : 12} className={`${isMob ? 'mt-c-20' : ''}`}>
                          <CareerWidgetOverlay title={interests.title}>
                            {interests.dataList?.length === 0 ? null
                              : (
                                <DrawerPersonIntent
                                  title={interests.title}
                                  buttons
                                />
                              )}
                            <div className="tips-details-wrapper">
                              {interests.dataList && interests.dataList?.map((d) => <TagTip title={d} marginTopBottom="5px" />)}
                            </div>
                          </CareerWidgetOverlay>
                        </Col>
                      )}
                    </Row>
                    {!guestUser ? <>
                      <Row gutter={16} className="pills-one-liner commonalities-container justify-content-center w-100">
                        {
                          commonalitiesLoading ? (
                            <Col span={24}>
                              <CareerWidgetOverlay title={commonalitiesTitle}>
                                <div className="d-flex flex-column">
                                  {[1, 2, 3].map((item) => (
                                    <ApproachTipSkeleton key={item} />
                                  ))}
                                </div>
                              </CareerWidgetOverlay>
                            </Col>
                          ) : searchedPersonLoading ? (
                            <Col span={24} className="100%">
                              <CareerWidgetOverlay title={commonalitiesTitle}>
                                <div className="d-flex flex-column ">
                                  {[1, 2, 3].map((item) => (
                                    <ApproachTipSkeleton key={item} />
                                  ))}
                                </div>
                              </CareerWidgetOverlay>
                            </Col>
                          ) : isSelectedSearchedPerson && commonalitiesData?.length > 0
                            && selectedPerson.personId !== personOther.personId
                            && selectedPerson.personId !== personYou.personId
                            ? (
                              <Col
                                span={24}
                                className={`approach-tips-area commonalities-area  ${commonalitiesData && commonalitiesData?.length > 0 ? 'm-tip-max ml-0 mr-0' : 'm-tip-min'}`}
                              >
                                <CareerWidgetOverlay title={commonalitiesTitle}>
                                  <div className={`${commonalitiesData?.length > 0 ? 'd-flex flex-direction-column align-items-center common-points' : ''}`}>
                                    {
                                      commonalitiesData?.map((item) => (
                                        <ListItem
                                          className={`${commonalitiesData?.length > 0 ? 'horizontal-tips' : ''}`}
                                          title={item}
                                          icon={(
                                            <CheckCircleFilled
                                              style={{ color }}
                                            />
                                          )}
                                          showTooltip={isMidWidth}
                                        />
                                      ))
                                    }
                                  </div>
                                </CareerWidgetOverlay>
                              </Col>
                            ) : commonalitiesData && commonalitiesData?.length > 0
                            && personYou.personId !== personOther.personId && (
                              <Col
                                span={24}
                                className={`approach-tips-area commonalities-area  ${commonalitiesData?.length > 0 ? 'm-tip-max ml-0 mr-0' : 'm-tip-min'}`}
                              >
                                <CareerWidgetOverlay title={commonalitiesTitle}>
                                  <div className={`${commonalitiesData?.length > 0 ? 'd-flex flex-direction-column align-items-center common-points' : ''}`}>
                                    {
                                      commonalitiesData.map((item) => (
                                        <ListItem
                                          className={`${commonalitiesData && commonalitiesData?.length > 0 ? 'horizontal-tips' : ''}`}
                                          title={item}
                                          icon={(
                                            <CheckCircleFilled
                                              style={{ color }}
                                            />
                                          )}
                                          showTooltip={isMidWidth}
                                        />
                                      ))
                                    }
                                  </div>
                                </CareerWidgetOverlay>
                              </Col>
                            )
                        }
                      </Row>
                    </> : null}
                  </Row>
                ) : isMultipleSalesAlignment && (
                  <Row
                    gutter={16}
                    className={classNames('pills-one-liner affinity-block multi-sales')}
                  >
                    <ToolTipAffinity>
                      <div className="left-section">
                        <div className='back-icon-div'>
                          <BackIcon onClick={() => { backBtnMultiSalesHandler() }} />
                        </div>
                        <HeadingTile>Multiple Sales Alignment</HeadingTile>
                        <Tooltip
                          arrow={false}
                          placement='bottomLeft'
                          title={tooltipText}
                          getPopupContainer={(e: HTMLElement) => e}
                          className="tooltip"
                          color='#fff'
                        >
                          <span className="icon-area">
                            <InfoIconTwo />
                          </span>
                        </Tooltip>
                      </div>
                    </ToolTipAffinity>
                    <Row gutter={16} className='pills-one-liner w-100'>
                      <Col span={24}>
                        <MultiSalesAlignment insights={insights} commonalitiesData={commonalitiesData} commonalitiesTitle={commonalitiesTitle} />
                      </Col>
                    </Row>
                  </Row>
                )}
              {interests && personYou && personOther
                && personYou.personId === personOther.personId
                ? (
                  <Row gutter={16} className="pills-one-liner">
                    <Col span={8} xs={24} sm={24} md={24} lg={8}>
                      <CareerWidgetOverlay title={interests.title}>
                        {interests.dataList?.length === 0 ? null
                          : (
                            <DrawerPersonIntent
                              title={interests.title}
                              buttons
                            />
                          )}
                        <div className="tips-details-wrapper">
                          {interests.dataList && interests.dataList?.map((d) => <TagTip title={d} marginTopBottom="5px" />)}
                        </div>
                      </CareerWidgetOverlay>
                    </Col>
                  </Row>
                ) : null}
              {dealingInfo && dealingInfo?.data?.length > 0 && !disclessPersonality ? (
                <>
                  <div className="head mt-c-50 change-view-sm">
                    <div className="left-side">
                      <Heading>{dealingInfo.title}</Heading>
                    </div>
                    <div className="right-side">
                      <LearnMore color={color}>
                        <DrawerPersonPersonality
                          personaColor={personProfileCard?.archeType?.color}
                          personality={personOther?.personName}
                          learnMoreText={`Learn More about "${personOther?.personName}"`}
                          disk={archeType && archeType?.image ? archeType?.image : ''}
                        />
                      </LearnMore>
                    </div>

                  </div>
                  <TimeLineWidget>
                    <TimeLineSlider sliderData={dealingInfo.data} personalityColor={color} />
                    <DisclaimerMessage label={DISCLAIMER_MESSAGE} className="timeLine-spacing" />
                  </TimeLineWidget>
                </>
              ) : null}
              {faqsLoading ? (
                <div className="mt-c-50">
                  {[1, 2, 3, 4, 5].map((index) => (
                    <FAQItem key={`sk-${index}`}>
                      <QuestionWrapper>
                        <SkeletonCustom
                          height="18px"
                          width="100%"
                          diameter="8px"
                          margin="0"
                        />
                      </QuestionWrapper>
                    </FAQItem>
                  ))}
                </div>
              ) : (
                (faqs && faqs?.length > 0) && (
                  <FAQs faqs={faqs} onFaqClick={onFaqClick} name={personOther?.personName} />
                )
              )}
              {!guestUser ? (
                <div className="people-group-section">
                  {
                    personGroupsLoaded && allPersonGroups.length > 0 && (
                      <div className="group-heading">
                        <Heading>{`${personProfileCard?.personName}'s Common Buyer Groups (${personGroupsCount})`}</Heading>
                      </div>
                    )
                  }
                  {
                    personGroupsLoading ? (
                      <div className="groups-slider">
                        <Row gutter={[12, 12]} className="tablet-row">
                          {
                            [1, 2, 3, 4].map(() => (
                              <Col lg={{ span: 6 }} xs={{ span: 24 }} sm={{ span: 12 }} className="tablet-col">
                                <BuyerGroupSkeleton />
                              </Col>
                            ))
                          }
                        </Row>
                      </div>
                    ) : personGroupsCount > 0 && (
                      <div className="groups-slider">
                        <Slider {...buyerGroupSlider}>
                          {
                            allPersonGroups.map((group) => (
                              <div key={group.groupId} className="buyer-group-slide">
                                <BuyerGroupCard
                                  groupId={group.groupId}
                                  groupName={group.groupName}
                                  groupPersona={group.groupPersonality}
                                  persons={group.persons}
                                  companies={group.companyLogos}
                                  members={group.personsCount}
                                  isShared={group.groupShared}
                                  sharedBy={group.sharedByFirstName}
                                  commonGroup
                                />
                              </div>
                            ))
                          }
                        </Slider>
                      </div>
                    )
                  }
                </div>) : null}

              {!guestUser ? (
                <div>
                  {similarLoading && !loaded ? <SearchPersonSkeletonBlock count={6} /> : (
                    <PersonalityBlock className="personality-block-styled-component mb-c-20 select-highlight-none">

                      {people && people.length
                        ? (
                          <>
                            <div className="head">
                              <div className="left-side">
                                <SimilarPeopleHeading className="text-truncate">
                                  {`${title} (${formattedCount})`}
                                </SimilarPeopleHeading>
                                <div className="similar-people-tooltip d-flex align-items-center">
                                  <HeadingWithToolTip
                                    toolTipText={TOOLTIP_SIMILAR_PEOPLE}
                                    midTabletFlag
                                    heightIcon="20px"
                                    heightIconSm="20px"
                                  />
                                </div>
                              </div>
                              <div className="right-side">
                                {/* {
                                disclessPersonality ? null : ( */}
                                {/* <div className="filter-similar-people">
                                  <FilterSimilarPeople
                                    personId={personProfileCard?.personId}
                                    filters={filters}
                                  />
                                </div> */}
                                {/* )
                              } */}
                                {/* <div className="export-similar-people">
                                  <GlobalButton
                                    title="Export"
                                    textColor="#7E7E7E"
                                    bgColor="#fff"
                                    outlineColor="#DADADA"
                                    innerSpace="9px 15px 9px 15px"
                                    LeftSpace="7px"
                                    IconLeft={exportLoading ? <Empty /> : <ExportIcon />}
                                    buttonClassName="share-button mr-24 export_btn"
                                    rightSeparatorClassName="right-separator-class"
                                    onButtonClick={handleExport}
                                    disabled={exportLoading}
                                    loading={exportLoading}
                                  />
                                </div> */}
                                {people.length > 6 ? (
                                  <LearnMore
                                    color={disclessPersonality ? nutenixColor : color}
                                    onClick={SeeAllOrLess}
                                  >
                                    See more
                                    <ArrowRightIcon
                                      color={disclessPersonality ? nutenixColor : color}
                                    />
                                  </LearnMore>
                                ) : null}

                              </div>
                            </div>
                            {similarLoading && page === 1
                              ? <SearchPersonSkeletonBlock count={6} /> : (
                                <Row className="Grid-width-row" gutter={[24, 24]} style={{ margin: '0' }}>
                                  {similarPeopleArr.map((person: Executive) => (
                                    <Col xxl={{ span: 4 }} xl={{ span: 4 }} lg={{ span: 6 }} className="gutter-row">
                                      <DragWrapper key={person?.personId} isDrag={isDrag}>
                                        <PeopleCardLarge
                                          key={person?.personId}
                                          personId={person?.personId}
                                          persona={person?.archeType?.color}
                                          logo={person?.personImage}
                                          personName={person?.personName}
                                          tag={person?.personDesignation}
                                          personaType={person?.archeType?.name}
                                          wrapperColor={
                                            backgroundColorParsing(person?.personalityTypes)
                                          }
                                          personalityTypesColors={
                                            person?.personalityTypes || EMPTY_PERSONALITY_TYPES
                                          }
                                          hidePersonality={false}
                                          company={person.companyName}
                                          follow={!person.personAdded}
                                          personAddedFlag={person.personAdded}
                                        />
                                      </DragWrapper>
                                    </Col>
                                  ))}
                                </Row>
                              )}

                          </>
                        ) : null}
                    </PersonalityBlock>
                  )}
                </div>
              ) : null}
            </Wrapper>
          </div>
        </Waypoint>
      )
  );
};

export default PersonalityInsight;